/* eslint-disable */
var $ = window.jQuery = require('jquery');

import addNewUser from '@/components/private/add-new-user/';
import addSubscriptionUser from '@/components/private/add-subscription/';
import axios from 'axios';
import {bus} from '@/main';
import countries from '@/services/country.json'
import flagUser from '@/components/flag-user/';
import {mapGetters} from 'vuex';
import toast from '@/services/toast';
import trashUser from '@/components/trash-user/';
import userSearchFilters from '@/components/user-search-filter/';

export default {
  name: 'users',
  components: {
    'add-new-user': addNewUser,
    'add-subscription-user': addSubscriptionUser,
    'trash-user' : trashUser,
    'user-filter':userSearchFilters,
    'flag-user': flagUser
  },
  props: [],
  data() {
    return {
      i: '',
      userList:null,
      name: '',
      submitted: false,
      userCreateform: false,
      totalCount: '',
      search: '',
      userListResults: [],
      is_active: Boolean,
      nextStep: '',
      loadmoreData: {},
      searchData: '',
      activeStatus: Boolean,
      userLoading: false,
      userSubscribeForm: false,
      selectedEmail: '',
      countryList: [],
      countryFilter: '',
      sortKey: '',
      sortNameDirection: 0,
      sortDateDirection: 0,
      authToken:'',
      apiEndpoint:'',
      userTrashId:'',
      userAcTrashPopup:false,
      email:'',
      countryName:'',
      userSearchData:'',
      userFlagPopup: false,
      userFlagId: '',
      userFlagStatus: '',
      showFlaggedUser: false
    }
  },
  computed: {
    ...mapGetters([
      'getuserListDetailsState',

    ]),
    getUserList() {
      return this.userList = this.$store.getters.getuserListDetailsState.data
    },
    SetIntialStatus() {
      if (this.userList) {
        this.totalCount = this.userList.count
        this.nextStep = this.userList.next
        this.userListResults = this.userList.results
      }
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getUserList
    this.SetIntialStatus
    bus.$on('HideAddNewUserPopup', (data) => {
      this.userCreateform = data;
    });
    bus.$on('UserAcTrashPopupBus', (data) => {
      this.userAcTrashPopup = data;
    });
    bus.$on('UserFlagPopupBus', (data) => {
      this.userFlagPopup = data;
    });
    bus.$on('HideAddSubscriptionPopup', (data) => {
      this.userSubscribeForm = data;
    });
    this.authToken = localStorage.getItem('token')
    this.apiEndpoint = process.env.VUE_APP_API_BASE_URL
    bus.$on('ShowUserSearchResults', (data) => {
      this.userListResults = data;
    });
  },
  methods: {
    sortData(sortKey) {
      this.userLoading = true;
      this.sortKey = sortKey;
      let direction = '';
      if (sortKey == 'last_name') {
        this.sortDateDirection = 0;
        this.sortNameDirection = this.sortNameDirection == 1 ? -1 : 1;
        direction = this.sortNameDirection == 1 ? '' : '-';
      }
      if (sortKey == 'date_joined') {
        this.sortNameDirection = 0;
        this.sortDateDirection = this.sortDateDirection == 1 ? -1 : 1;
        direction = this.sortDateDirection == 1 ? '' : '-';
      }
      let params = '';
      if (this.countryFilter != '') {
        params = '&country=' + this.countryFilter;
      }
      axios.get('/account/admin/users/?order_by=' + direction + sortKey + params)
        .then((response) => {
          if (response.status == '200') {
            this.userList = response.data.data
            this.search = ''
            this.$validator.reset()
            this.userLoading = false
          }
        })
        .catch((err) => {
          this.userLoading = false
        })
    },
    filterFlagUser() {
      this.userLoading = true;
      let params = '';
      this.showFlaggedUser =! this.showFlaggedUser;
      if(this.showFlaggedUser) {
        params = '?is_flagged=True';
      } else {
        params = '';
      }
      axios.get('/account/admin/users/'+params)
        .then((response) => {
          if (response.status == '200') {
            this.userList = response.data.data
            this.search = ''
            this.$validator.reset()
            this.userLoading = false
          }
        })
        .catch((err) => {
          this.userLoading = false
        })
    },
    filterByCountry() {
      this.userLoading = true
      axios.get('/account/admin/users/?country=' + this.countryFilter)
        .then((response) => {
          if (response.status == '200') {
            this.userList = response.data.data
            this.search = ''
            this.$validator.reset()
            this.userLoading = false
          }
        })
        .catch((err) => {
          this.userLoading = false
        })
    },
    getUserListAgain() {
      this.$store.dispatch('getUserListDetails').then((res) => {}).catch((err) => {})
    },
    addUserFun() {
      this.userCreateform = true
    },
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          // debugger
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          // console.log(this.loadmoreData, this.nextStep)
          this.$set(this.userList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            // debugger
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
            // toast.success(this.loadmoreData.msg);
            // this.userList.push(this.loadmoreData)
          }
        });
    },
    validateSearchUserBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.searchData = this.search
          if (this.searchData) {
            this.submitted = true;
            axios.get('/account/admin/users/?name=' + this.searchData)
              .then((response) => {
                if (response.status == '200') {
                  this.userList = response.data.data
                  //toast.success(response.data.msg)
                  console.log(this.userList)
                  // this.search = ''
                  this.$validator.reset()
                }
              })
              .catch((err) => {})
          }
        }
      })
    },
    updateSubscriptionStatus(userId, $event, emailId) {
      if (!$event.target.checked) {
        let data = {
          id: userId
        }
        this.$store.dispatch('getUserSubscriptionById', data)
          .then((res) => {
            console.log(res)
            if (res.data.code == 2000) {
              this.getUserListAgain()
              toast.success("User Subscription Updated Successfully");
            }
            return
          }).catch((err) => {})
      } else {
        this.userSubscribeForm = true;
        this.selectedEmail = emailId;
        $event.preventDefault();
      }
    },
    userActStatusFun(id) {
      let activeStatusUserId = '';
      this.activeStatusUserId = id;
      let data = {
        id: this.activeStatusUserId
      }
      this.$store.dispatch('getUserListDetailsById', data)
        .then((res) => {
          this.activeStatus = this.$store.getters.getUserDetailsByIdState.data.user_details.is_active
          if (this.activeStatus === true) {
            this.is_active = false
          }
          if (this.activeStatus === false) {
            this.is_active = true
          }
          let data = {
            is_active: this.is_active,
          }
          this.$store.dispatch('UpdateUserDetailsById', {
            data: {
              data: data,
              id: id
            }
          }).then((res) => {
            if (res.status == '200') {
              this.getUserListAgain()
              toast.success("User Status Updated Successfully");
            }
          }).catch((err) => {})
          return
        }).catch((err) => {})
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    showRListUser: function() {
      this.$router.push('/rlist-users/');
    },
    showExportAllUser(){
      this.$store.dispatch('getExportUserDetails')
      .then((res) => {
        const type = res.headers['content-type']
        let blob = new Blob([res.data], { type: type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'file.xls'
        link.click()
      })
      .catch((err) => {})
      return
    },
    userAcTrash(id){
      this.userTrashId = id
      this.userAcTrashPopup = true
    },
    showFlagUnflagUserPopup(userId, flagStatus) {
      this.userFlagId = userId;
      this.userFlagStatus = flagStatus;
      this.userFlagPopup = true;
    },
    userTransferRList(email, fname, lname, country, autocountry, mobile_no){
      if(country){
       this.countryName = country
      }else{
        this.countryName = autocountry
      }
      let data = {
        email : email,
        first_name : fname,
        last_name : lname,
        country: this.countryName,
        mobile: mobile_no
      }
      this.$store.dispatch('createRListUserList', data).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getuserListDetailsState
    },
    SetIntialStatus() {
      if (this.userList) {
        this.totalCount = this.userList.count
        this.nextStep = this.userList.next
        this.userListResults = this.userList.results
      }
    }
  }
}
